// extracted by mini-css-extract-plugin
module.exports = {"MenuArea":"CircleMenu_MenuArea__1t9UA","hide":"CircleMenu_hide__sFBeo","TouchArea":"CircleMenu_TouchArea__6LqEB","StartingPoint":"CircleMenu_StartingPoint__PjCJ7"};